module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"param":{"countType":"Count method","minOccurrences":"Minimum number of occurrences","numberToKeep":"Maximum number of entities to keep","dropFullyMentioned":"Drop entities already fully contained in the collection, as they are not useful","normalizeMaxScore":"Normalize so the score of the top entity is 1.0"}}}')
  delete Component.options._Ctor
}
